import latestSchema from './v3';

export default latestSchema;
